import { configureStore } from '@reduxjs/toolkit'
import dashboardActiveReport from './Fetures/DashboardActiveSlice'

export const store = configureStore({
    reducer: {
        dashboardActivePage:dashboardActiveReport,
    },
   
})